<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer 
      color="rgba(0,0,0,.057)"
      name="footer" 
      app
      absolute 
      class="d-flex align-center pa-4"
    >
      <p class="text-caption font-weight-medium mx-2">CHECKTAK - {{ currentYear }} ©</p>
      <v-spacer></v-spacer>
      <ThemeToggle />
      <v-spacer></v-spacer>
      <LanguageSwitcher />
    </v-footer>
  </v-app>
</template>

<script setup>
import { computed } from 'vue'
import ThemeToggle from './components/ThemeToggle.vue'
import LanguageSwitcher from './components/LanguageSwitcher.vue'
import { useThemeManager } from './composables/useTheme'

const {  initTheme } = useThemeManager()

// Вызываем ДО монтирования, чтобы тема применилась раньше
initTheme()

// Computed свойство для текущего года
const currentYear = computed(() => new Date().getFullYear())
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

:root {
  --font-family: 'Montserrat', sans-serif;
}

* {
  font-family: var(--font-family) !important;
}

.v-application {
  font-family: var(--font-family) !important;
}

/* Для всех typography классов */
.text-h1, .text-h2, .text-h3, .text-h4, .text-h5, .text-h6,
.text-subtitle-1, .text-subtitle-2, .text-body-1, .text-body-2,
.text-button, .text-caption, .text-overline {
  font-family: var(--font-family) !important;
}
</style>
